var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _vm.label
        ? _c("h5", [
            _vm._v("\n        " + _vm._s(_vm._f("capitalize")(_vm.label))),
            _c("br")
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("my-checkbox", {
        ref: "my_checkbox",
        attrs: {
          options: _vm.items ? _vm.items : [_vm.item],
          label: _vm.label,
          name: _vm.name,
          clearable: _vm.clearable,
          "allow-empty": _vm.allowEmpty,
          multiple: _vm.multiple,
          "track-by": "id"
        },
        on: { input: _vm.valueUpdated },
        model: {
          value: _vm.current_value,
          callback: function($$v) {
            _vm.current_value = $$v
          },
          expression: "current_value"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }